import React, { useEffect } from "react";
import { createBrowserRouter, Route, Link, RouterProvider, Navigate } from "react-router-dom";
import './App.scss';
import Button from '@mui/material/Button';

//Login
// import SignIn from "./components/Login/SignIn";
// import SignUp from "./components/Login/SignUp";
//ordenes
import AddOrdenes from './pages/Ordenes/AddOrdenes';
import AddServices from './pages/Services/AddServices';
import AddMaterials from './pages/Materials/AddMaterials';
import Layout from './components/Layout/Layout';
import ListOrdenes from './pages/Ordenes/ListOrdenes';
import ListPrices from './pages/Prices/ListPrices';
import EditPrices from './pages/Prices/EditPrices';
import StockList from './pages/Stock/StockList';
import AddRemito from './pages/Stock/AddRemito';
import SignIn from './pages/Login/SignIn';
import SignUp from './pages/Login/SignUp';
import ListUsers from './pages/Login/ListUsers';
import ListCuadrillas from './pages/Cuadrillas/ListCuadrillas';
import EditCuadrilla from './pages/Cuadrillas/EditCuadrilla';
import AddCuadrilla from './pages/Cuadrillas/AddCuadrillas';
import ListFuncionarios from './pages/Cuadrillas/ListFuncionarios';
import AddFuncionario from './pages/Cuadrillas/AddFuncionario';
import EditFuncionario from './pages/Cuadrillas/EditFuncionario';
import ListHerramientas from './pages/Herramientas/ListHerramientas';
import AddHerramienta from './pages/Herramientas/AddHerramienta';
import EditHerramienta from './pages/Herramientas/EditHerramienta';
import StockHerramientas from './pages/Herramientas/StockHerramientas';
import AddRemitoHerramientas from './pages/Herramientas/AddRemitoHerramientas';
import RemitoHerramientasList from './pages/Herramientas/RemitoHerramientasList';
import FacturaRemitoHerramientas from './pages/Herramientas/FacturaRemitoHerramientas';
import ErrorPage from './components/ErrorPage/ErrorPage';
import FacturaRemito from './pages/Stock/FacturaRemito';
import ListRemitos from './pages/Stock/RemitoList';
import MovimientosMateriales from './pages/Registros/MovimientosMateriales';
import SerialesSearch from './pages/Seriales/SerialesSearch';
import ListRegistros from './pages/Registros/ListRegistros';
import OTWrapper from "./pages/Ordenes/OTWrapper";
import GarantiasExcel from "./pages/Garantias/GarantiasExcel";
import AddAsistencia from "./pages/Asistencia/AddAsistencia";
import ListAsistencias from "./pages/Asistencia/ListAsistencias";
import Produccion from "./pages/Estadisticas/Produccion";
import ProdxUser from "./pages/Estadisticas/ProdxUser";
import EstadisticasGarantias from "./pages/Estadisticas/Garantias";
import ReporteComisiones from "./pages/Reportes/ReporteComisiones";
import OTsList from "./pages/Ordenes/OTsList";
import Adelantos from "./pages/PagosCuadrillas/Adelantos";
import Combustible from "./pages/PagosCuadrillas/Combustible";
import Descuentos from "./pages/PagosCuadrillas/Descuentos";
import ListMateriales from './pages/Materiales/ListMateriales';
import AddMateriales from './pages/Materiales/AddMateriales';
import EditMaterial from './pages/Materiales/EditMaterial';
import ListServiciosGeneral from './pages/Services/ListServicios';
import AddServicio from './pages/Services/AddServicio';
import EditServicio from './pages/Services/EditServicio';

// Hub
import Hub from './pages/Hub/Hub';
// Huawei
import ListServicios from './pages/Huawei/Servicios/ListServicios';
import ListObras from './pages/Huawei/Obras/ListObras';
import ListRemitosHuawei from './pages/Huawei/Remitos/ListRemitos';
import AddRemitoHuawei from './pages/Huawei/Remitos/AddRemito';
import ListMaterialesHuawei from './pages/Huawei/Materiales/ListMateriales';
import ListStockHuawei from './pages/Huawei/Stock/ListStock';
import ListCuadrillasHuawei from './pages/Huawei/Cuadrillas/ListCuadrillas';
import ListTrabajosHuawei from './pages/Huawei/Trabajos/ListTrabajos';
import AddTrabajoHuawei from './pages/Huawei/Trabajos/AddTrabajo';
import EditTrabajoHuawei from './pages/Huawei/Trabajos/EditTrabajo';

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const router = createBrowserRouter([
  {
    path: "/login",
    element: <SignIn />
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: currentUser ? <ListOrdenes /> : <Navigate to="/login" replace />
      },
      {
        path: "hub",
        element: currentUser ? <Hub /> : <ErrorPage />
      },
      {
        path: "ordenes",
        element: currentUser ? <OTWrapper /> : <ErrorPage />
      },
      {
        path: "ordenes-new",
        element: currentUser ? <OTWrapper /> : <ErrorPage />
      },
      {
        path: "list-ordenes",
        element: currentUser ? <ListOrdenes /> : <ErrorPage />
      },
      {
        path: "services/:id",
        element: currentUser ? <AddServices /> : <ErrorPage />
      },
      {
        path: "materials/:id",
        element: currentUser ? <AddMaterials /> : <ErrorPage />
      },
      {
        path: "prices",
        element: currentUser && currentUser?.rol === 'admin' ? <ListPrices /> : <ErrorPage />
      },
      {
        path: "prices/:id",
        element: currentUser && currentUser?.rol === 'admin' ? <EditPrices /> : <ErrorPage />
      },
      {
        path: "servicios",
        element: currentUser && currentUser?.rol === 'admin' ? <ListServiciosGeneral /> : <ErrorPage />
      },
      {
        path: "add-servicio",
        element: currentUser && currentUser?.rol === 'admin' ? <AddServicio /> : <ErrorPage />
      },
      {
        path: "servicio/:id",
        element: currentUser && currentUser?.rol === 'admin' ? <EditServicio /> : <ErrorPage />
      },
      {
        path: "stock",
        element: currentUser ? <StockList /> : <ErrorPage />
      },
      {
        path: "remito",
        element: currentUser ? <AddRemito /> : <ErrorPage />
      },
      {
        path: "remito-list",
        element: currentUser ? <ListRemitos /> : <ErrorPage />
      },
      {
        path: "movimientos-materiales",
        element: currentUser ? <MovimientosMateriales /> : <ErrorPage />
      },
      {
        path: "register",
        element: currentUser && currentUser?.rol === 'admin' ? <SignUp /> : <ErrorPage />
      },
      {
        path: "list-users",
        element: currentUser && currentUser?.rol === 'admin' ? <ListUsers /> : <ErrorPage />
      },
      {
        path: "cuadrillas",
        element: currentUser ? <ListCuadrillas /> : <ErrorPage />
      },
      {
        path: "add-cuadrilla",
        element: currentUser ? <AddCuadrilla /> : <ErrorPage />
      },
      {
        path: "cuadrilla/:id",
        element: currentUser ? <EditCuadrilla /> : <ErrorPage />
      },
      {
        path: "funcionarios",
        element: currentUser ? <ListFuncionarios /> : <ErrorPage />
      },
      {
        path: "add-funcionario",
        element: currentUser ? <AddFuncionario /> : <ErrorPage />
      },
      {
        path: "funcionario/:id",
        element: currentUser ? <EditFuncionario /> : <ErrorPage />
      },
      {
        path: "herramientas",
        element: currentUser ? <ListHerramientas /> : <ErrorPage />
      },
      {
        path: "add-herramienta",
        element: currentUser ? <AddHerramienta /> : <ErrorPage />
      },
      {
        path: "herramienta/:id",
        element: currentUser ? <EditHerramienta /> : <ErrorPage />
      },
      {
        path: "herramientas-stock",
        element: currentUser ? <StockHerramientas /> : <ErrorPage />
      },
      {
        path: "herramientas-remito",
        element: currentUser ? <AddRemitoHerramientas /> : <ErrorPage />
      },
      {
        path: "herramientas-remitos-list",
        element: currentUser ? <RemitoHerramientasList /> : <ErrorPage />
      },
      {
        path: "imprimir-herramienta/:id",
        element: currentUser ? <FacturaRemitoHerramientas /> : <ErrorPage />
      },
      {
        path: "imprimir/:id",
        element: currentUser ? <FacturaRemito /> : <ErrorPage />
      },
      {
        path: "seriales",
        element: currentUser ? <SerialesSearch /> : <ErrorPage />
      },
      {
        path: "registros",
        element: currentUser && currentUser?.rol === 'admin' ? <ListRegistros /> : <ErrorPage />
      },
      {
        path: "garantias",
        element: currentUser ? <GarantiasExcel /> : <ErrorPage />
      },
      {
        path: "asistencia",
        element: currentUser && (currentUser?.rol === 'admin' || currentUser?.rol === 'write') ? <AddAsistencia /> : <ErrorPage />
      },
      {
        path: "asistencia-list",
        element: currentUser ? <ListAsistencias /> : <ErrorPage />
      },
      {
        path: "produccion-cuadrillas",
        element: currentUser && currentUser?.rol === 'admin' ? <Produccion /> : <ErrorPage />
      },
      {
        path: "produccion-user",
        element: currentUser && currentUser?.rol === 'admin' ? <ProdxUser /> : <ErrorPage />
      },
      {
        path: "estadisticas-garantias",
        element: currentUser ? <EstadisticasGarantias /> : <ErrorPage />
      },
      {
        path: "liquidacion",
        element: currentUser && currentUser?.rol === 'admin' ? <ReporteComisiones /> : <ErrorPage />
      },
      {
        path: "adelantos",
        element: currentUser && currentUser?.rol === 'admin' ? <Adelantos /> : <ErrorPage />
      },
      {
        path: "combustible",
        element: currentUser && (
          currentUser?.rol === 'admin' ||
          currentUser?.rol === 'write' ||
          ['ivan.riego@cbaconstruir.com.py', 'marco.barreto@cbaconstruir.com.py'].includes((currentUser?.email || currentUser?.user || currentUser?.usuario || '').toLowerCase())
        ) ? <Combustible /> : <ErrorPage />
      },
      {
        path: "descuentos",
        element: currentUser && (
          currentUser?.rol === 'admin' ||
          currentUser?.rol === 'write' ||
          ['isabel.ortega@cbaconstruir.com.py', 'fiorelha.sandoval@cbaconstruir.com.py', 'isabelortega', 'fiorelhasandoval', 'isabel.ortega', 'fiorelha.sandoval'].some(u =>
            (currentUser?.email || currentUser?.user || currentUser?.usuario || '').toLowerCase().includes(u) ||
            (currentUser?.userName || '').toLowerCase().includes(u)
          )
        ) ? <Descuentos /> : <ErrorPage />
      },
      {
        path: "ots-list",
        element: currentUser ? <OTsList /> : <ErrorPage />
      },
      {
        path: "materiales",
        element: currentUser ? <ListMateriales /> : <ErrorPage />
      },
      {
        path: "add-material",
        element: currentUser ? <AddMateriales /> : <ErrorPage />
      },
      {
        path: "material/:id",
        element: currentUser ? <EditMaterial /> : <ErrorPage />
      },
      // Rutas Huawei
      {
        path: "huawei/ordenes",
        element: currentUser ? <ListOrdenes /> : <ErrorPage />
      },
      {
        path: "huawei/servicios",
        element: currentUser ? <ListServicios /> : <ErrorPage />
      },
      {
        path: "huawei/obras",
        element: currentUser ? <ListObras /> : <ErrorPage />
      },
      {
        path: "huawei/remitos",
        element: currentUser ? <ListRemitosHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/remito-add",
        element: currentUser ? <AddRemitoHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/materiales",
        element: currentUser ? <ListMaterialesHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/stock",
        element: currentUser ? <ListStockHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/cuadrillas",
        element: currentUser ? <ListCuadrillasHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/trabajos",
        element: currentUser ? <ListTrabajosHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/trabajo-add",
        element: currentUser ? <AddTrabajoHuawei /> : <ErrorPage />
      },
      {
        path: "huawei/trabajo-edit/:id",
        element: currentUser ? <EditTrabajoHuawei /> : <ErrorPage />
      },
      {
        path: "*",
        element: <ErrorPage />
      }
    ]
  }
]);

function App() {
  // const { pathname } = useLocation();
  // const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  // const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  // const handleCloseUserMenu = () => {
  //   setAnchorElUser(null);
  // };

  // useEffect(() => {
  //   if (pathname === '/') {
  //     window.location.href = '/list-ordenes'
  //   }
  // }, []);

  return (
    <div className="App">
      <RouterProvider router={router} />
      {/* <div>
        <h2>
          SITIO EN CONSTRUCCIÓN
        </h2>
        <Button variant="outlined">Outlined</Button>
      </div>
      <div>SUCRE 3085. CÓRDOBA. ARG. CEL.: +54 9 3513 58-7901</div> */}
      {/* <Switch> */}
      {/* <Route exact path={["/ordenes"]} component={AddOrdenes} /> */}
      {/*
            <Route
              exact
              path={!currentUser ? ["/", "/login"] : "/login"}
              component={SignIn}
            />
            <Route exact path="/register" component={SignUp} />
            <Route exact path="/profile" component={Profile} /> */}

      {/* {currentUser ? (
            <div></div>
            ) : (
              <Redirect to="/login" />
            )} */}
      {/* </Switch> */}
      {/* <FooterView /> */}
    </div>
  );
}

export default App;
